module.exports = __webpack_public_path__ + "static/img/client_upgraded_cn.e19a28d1.png";